import { api } from './api';
import type {
  Friend,
  FriendRequest,
  FriendSearchResult,
  PendingRequestsCount,
  FriendPortfolioResponse,
} from '@pokefolio/types';

export const friendsService = {
  /**
   * Rechercher des utilisateurs par pseudo ou code ami
   */
  async searchUsers(query: string): Promise<FriendSearchResult[]> {
    const { data } = await api.get<FriendSearchResult[]>('/friends/search', {
      params: { query },
    });
    return data;
  },

  /**
   * Obtenir la liste des amis
   */
  async getFriends(): Promise<Friend[]> {
    const { data } = await api.get<Friend[]>('/friends');
    return data;
  },

  /**
   * Obtenir les demandes d'ami reçues
   */
  async getReceivedRequests(): Promise<FriendRequest[]> {
    const { data } = await api.get<FriendRequest[]>('/friends/requests/received');
    return data;
  },

  /**
   * Obtenir les demandes d'ami envoyées
   */
  async getSentRequests(): Promise<FriendRequest[]> {
    const { data } = await api.get<FriendRequest[]>('/friends/requests/sent');
    return data;
  },

  /**
   * Obtenir le nombre de demandes reçues en attente
   */
  async getPendingRequestsCount(): Promise<number> {
    const { data } = await api.get<PendingRequestsCount>('/friends/requests/pending-count');
    return data.count;
  },

  /**
   * Envoyer une demande d'ami
   */
  async sendFriendRequest(query: string): Promise<FriendRequest> {
    const { data } = await api.post<FriendRequest>('/friends/requests', { query });
    return data;
  },

  /**
   * Accepter une demande d'ami
   */
  async acceptFriendRequest(requestId: string): Promise<void> {
    await api.put(`/friends/requests/${requestId}/accept`);
  },

  /**
   * Refuser une demande d'ami
   */
  async rejectFriendRequest(requestId: string): Promise<void> {
    await api.put(`/friends/requests/${requestId}/reject`);
  },

  /**
   * Annuler une demande d'ami envoyée
   */
  async cancelFriendRequest(requestId: string): Promise<void> {
    await api.delete(`/friends/requests/${requestId}`);
  },

  /**
   * Supprimer un ami
   */
  async removeFriend(friendId: string): Promise<void> {
    await api.delete(`/friends/${friendId}`);
  },

  /**
   * Récupérer le portfolio d'un ami
   * Note: La visite est automatiquement loggée côté backend
   */
  async getFriendPortfolio(friendId: string): Promise<FriendPortfolioResponse> {
    const { data } = await api.get<FriendPortfolioResponse>(`/friends/${friendId}/portfolio`);
    return data;
  },
};
